window.M = window.M || {};

window.M.Notifications = {
	init: function() {
		// Let's check if the browser supports notifications
		if (!("Notification" in window)) {
			window.Notification = {permission: "denied"};
		}

		// Let's check whether notification permissions have already been granted
		else if (Notification.permission === "granted") {
			// rad
		}

		// Otherwise, we need to ask the user for permission
		else if (Notification.permission !== 'denied') {
			Notification.requestPermission(function (permission) {
				// If the user accepts, let's create a notification
				if (permission !== Notification.permission) {
					Notification.permission = permission;
				}
			});
		}
	},
	create: function(title, options) {
		if(Notification.permission == "granted") {
			if(!options.icon) {
				options.icon = "/images/sensei.png";
			}
			var not = new Notification(title, options);
			
			return not;
		}
		
		return null;
	}
};